module.exports = __webpack_public_path__ + "img/1 (72).4d2b622d.png";